import { fetchToken } from "../../../common/FetchCookie";
import {
  BASE_URL,
  CANDIDATE,
  CANDIDATE_EMPLOYMENT,
} from "../../../common/URLs";

export const addExperience = async (info) => {
  try {
    // console.log("data in the experience API: ", info.userData, info.token);
    const token = await fetchToken();

    const response = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_EMPLOYMENT}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(info.userData),
      }
    );
    const responseData = await response.json();
    // console.log("Response Data: ", responseData.response);
    return responseData.response;
  } catch (error) {
    console.error("Error in saving the data: ", error);
    throw error;
  }
};
export const updateCandidateExperience = async (
  uuid,
  CandidateExperienceData
) => {
  try {
    const token = await fetchToken()
    const response = await fetch(
      `${BASE_URL}/${CANDIDATE}/${CANDIDATE_EMPLOYMENT}/${uuid}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(CandidateExperienceData),
      }
    );
    // console.log("Data:", CandidateExperienceData)

    if (!response.ok) {
      throw new Error("Error updating job : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job : " + error.message);
  }
};
